module.exports = __webpack_public_path__ + "img/loader.4c28c18e.gif";